export default __webpack_public_path__ + "static/cafe_36060-da9c218f5146c507cb8b9330d9993203.png";